// עזרי UI קטנים — בלי alert/confirm של הדפדפן לעולם.

let toastTimer: number | undefined;

export function toast(message: string, kind: 'ok' | 'error' = 'ok'): void {
  let el = document.getElementById('toast');
  if (!el) {
    el = document.createElement('div');
    el.id = 'toast';
    document.body.appendChild(el);
  }
  el.textContent = message;
  el.className = `show ${kind}`;
  // קורא מסך מקריא את ההודעה; שגיאה — מיד (alert), אישור — בנימוס (status)
  el.setAttribute('role', kind === 'error' ? 'alert' : 'status');
  el.setAttribute('aria-live', kind === 'error' ? 'assertive' : 'polite');
  window.clearTimeout(toastTimer);
  // שגיאה מסבירה (מה קרה ומה לעשות) צריכה זמן קריאה — ~65ms לתו, בין 2.6 ל-8 שניות
  const ms = kind === 'error' ? Math.min(8000, Math.max(2600, message.length * 65)) : 2600;
  toastTimer = window.setTimeout(() => el!.classList.remove('show'), ms);
}

/**
 * טוסט עם כפתור ביטול — הפעולה כבר בוצעה, והכפתור מפעיל שחזור.
 * (העדפת המשתמש: undo במקום דיאלוגי אישור.)
 */
export function undoToast(message: string, onUndo: () => void): void {
  document.getElementById('toast')?.remove();
  const el = document.createElement('div');
  el.id = 'toast';
  el.className = 'show with-undo';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.append(message);
  const btn = document.createElement('button');
  btn.textContent = 'ביטול';
  btn.addEventListener('click', () => {
    el.remove();
    onUndo();
  });
  el.appendChild(btn);
  document.body.appendChild(el);
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => el.remove(), 5000);
}

export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string),
  );
}
